import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Layout from '@bubble-ui/primitive-layout';
import View from '@bubble-ui/primitive-view';
import { compose, withState } from 'recompose';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Text from '@bubble-ui/primitive-text';

var SizeMarker = function SizeMarker(_ref) {
  var onTextDimensions = _ref.onTextDimensions,
      centered = _ref.centered,
      value = _ref.value,
      textDimensions = _ref.textDimensions,
      _ref$leftLinesLength = _ref.leftLinesLength,
      leftLinesLength = _ref$leftLinesLength === void 0 ? 5 : _ref$leftLinesLength;
  return /*#__PURE__*/React.createElement(View, {
    style: {
      position: 'relative',
      backgroundColor: 'transparent'
    }
  }, /*#__PURE__*/React.createElement(Surface, {
    width: leftLinesLength,
    height: value
  }, /*#__PURE__*/React.createElement(Shape, {
    d: "M0,0 ".concat(leftLinesLength, ",0 ").concat(leftLinesLength, ",1 0,1"),
    fill: "#FF5500"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M0,".concat(value, " ").concat(leftLinesLength, ",").concat(value, " ").concat(leftLinesLength, ",").concat(value - 1, " 0,").concat(value - 1),
    fill: "#FF5500"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M".concat(leftLinesLength - 3, ",0 ").concat(leftLinesLength - 3, ",").concat(value, " ").concat(leftLinesLength - 2, ",").concat(value, " ").concat(leftLinesLength - 2, ",0"),
    fill: "#FF5500"
  })), /*#__PURE__*/React.createElement(Layout, {
    onResize: onTextDimensions,
    style: _objectSpread({
      height: 22,
      backgroundColor: '#FF5500',
      borderRadius: 2,
      paddingLeft: 5,
      paddingRight: 5,
      position: 'absolute',
      top: 0,
      transform: [{
        translateY: (value - 22) / 2
      }]
    }, centered ? {
      left: 0,
      transform: [{
        translateY: (value - 22) / 2
      }, {
        translateX: -(textDimensions.width / 2)
      }]
    } : {
      left: leftLinesLength + 10,
      transform: [{
        translateY: (value - 22) / 2
      }]
    })
  }, function () {
    return /*#__PURE__*/React.createElement(Text, {
      style: {
        color: 'white',
        lineHeight: 22,
        fontFamily: 'Helvetica',
        fontSize: 12
      }
    }, value, "px");
  }));
};

export default compose(withState('textDimensions', 'onTextDimensions', {
  width: 0
}))(SizeMarker);
//# sourceMappingURL=index.js.map